module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title-head",
    attrs: {
      "id": "Intro"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")])])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_vm._v("Throughout the ages, humans have had a need to mark the time and place when and where people make the final stop on their journey from this world to the next. Sometimes the marker is a simple cross on rock-covered earth; at other times, it is an elaborate tombstone that tells something of the individual’s life. Early graves were placed close together without regard to religion, fraternal association, or nationality, but as urban areas grew, people became more picky about whom they did the final big sleepover with. One commonality across these disparate groups is the observance of rituals that are supposed to ward off evil spirits and guarantee the deceased a safe journey to heaven. The tombstones might be simple wooden crosses with inscriptions or structures richly covered with symbolism. Some rituals—the firing of guns, the ringing of funeral bells, the wailing of chants—are intended to scare away other ghosts. In many cemeteries, graves are oriented so that bodies lie with their heads to the west, a practice attributed to the belief that the final summons to judgment will come from the east.")])]), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('img', {
    staticClass: "img-60",
    attrs: {
      "alt": "Image",
      "src": "images/Page8-F1.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_vm._v("Sasabe, Arizona, and Sasabe, Sonora, Mexico, grew out of a private development by rancher Carlos Escalante. Situated on the border, a customhouse for these two towns was erected in 1935. The Sasabe cemeterio, pictured here while decorated for the Day of the Dead, reflects the influence of the culture that shaped Arizona. Día de los Muertos (Day of the Dead) is a festive occasion characterized by families visiting cemeteries, placing marigolds on headstones, making offerings to the dead, and exchanging sugar skeletons and skulls.")])])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img-70",
    attrs: {
      "alt": "Image",
      "src": "images/Page8-F2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Our Lady of Guadalupe is the only saint who wears a full-body halo, or "), _c('i', [_vm._v("esplendora")]), _vm._v(". While walking from his village to Mexico City on December 9, 1531, a peasant named Juan Diego saw a woman surrounded by light. He recognized the Virgin Mary and told his story to Archbishop Zumárraga, who instructed him to ask her for a miraculous sign to prove her identity. The Virgin told Juan Diego to gather flowers from the top of Tepeyac Hill even though it was December. He found roses, which he took to the archbishop. When he opened his cloak before Zumárraga, the roses fell to the floor and left the image of the Virgin of Guadalupe on the fabric.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7537d72c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Introduction.vue
// module id = 78
// module chunks = 0